<template>
  <label>{{ translate(`${LOCALE_PREFIX}.form.mealEquivalency`) }}</label>
  <SelectButtonField
    id="isBrandMEQ"
    :name="`${formNamespace}isBrandMEQ`"
    :options="brandMEQOptions"
    optionLabel="label"
    optionValue="value"
    :unselectable="false"
    :disabled="isBrandMX || isBrandMXFieldValue || !hasMEQTenders || !editMealPlan"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { inject } from 'vue';
import { useFieldValue } from 'vee-validate';
import useTranslation from '@centric-os/helpers/src/composables/use-translation';
import { SitesLocalePrefix } from '../../../../../../enums/locale-prefixs';
import { useFinancialConfigStore } from '../../../../../../routes/stores/use-financial-config-store';
import useTenderType from '../../composables/use-tender-type/use-tender-type';

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

const { brandMEQOptions, isBrandMX, hasMEQTenders } = useTenderType();

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
const isBrandMXFieldValue = useFieldValue<string>(`${formNamespace}isBrandMX`);
</script>
